pageId = 'teams-dashboards-show'

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  $('#nav-dashboard').addClass 'active'
